export const escapeRegex = (string: string) =>
  string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

export function filterList<T>(
  filterValue: string,
  filterFieldName: string,
  filteredList: T[],
  mainList: T[],
  isMultiListSelector?: boolean,
): T[] {
  if (filterValue) {
    return mainList?.filter((item) =>
      item[filterFieldName]
        ?.toLowerCase()
        ?.includes(filterValue?.toLowerCase()),
    );
  }
  if (filteredList?.length !== mainList?.length || isMultiListSelector) {
    return [...mainList];
  }
  return null;
}
